"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgDumbbellOutline = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { clipRule: 'evenodd', d: 'M18 8c1.974 0 4 1.56 4 4 0 2-1.573 4-4 4-1.625 0-2.63-.884-3.124-1.5H9.123a4 4 0 11.005-4.994l1.485-.001h4.245C15.52 8.658 16.722 8 18 8zm0 2c-1.267 0-1.874 1.085-1.936 1.502H7.938a2 2 0 100 .997l8.113.001h.013c.065.374.608 1.5 1.936 1.5 1.147 0 2-.922 2-2 0-1.078-.854-2-2-2z' }))); };
exports.default = SvgDumbbellOutline;
//# sourceMappingURL=DumbbellOutline.js.map